"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonDataHooks = exports.RadioButtonDataKeys = exports.RadioButtonTheme = void 0;
var RadioButtonTheme;
(function (RadioButtonTheme) {
    RadioButtonTheme["Default"] = "default";
    RadioButtonTheme["Box"] = "box";
})(RadioButtonTheme = exports.RadioButtonTheme || (exports.RadioButtonTheme = {}));
var RadioButtonDataKeys;
(function (RadioButtonDataKeys) {
    RadioButtonDataKeys["Disabled"] = "data-disabled";
    RadioButtonDataKeys["Checked"] = "data-checked";
    RadioButtonDataKeys["Focused"] = "data-focused";
    RadioButtonDataKeys["Required"] = "data-required";
})(RadioButtonDataKeys = exports.RadioButtonDataKeys || (exports.RadioButtonDataKeys = {}));
var RadioButtonDataHooks;
(function (RadioButtonDataHooks) {
    RadioButtonDataHooks["RadioButtonWrapper"] = "radiobutton-wrapper";
    RadioButtonDataHooks["IconWrapper"] = "icon-wrapper";
    RadioButtonDataHooks["LabelWrapper"] = "label-wrapper";
    RadioButtonDataHooks["coreRadioButton"] = "core-radio-button";
})(RadioButtonDataHooks = exports.RadioButtonDataHooks || (exports.RadioButtonDataHooks = {}));
//# sourceMappingURL=types.js.map